/**
 * An enumeration of the types of clause link that can be created in MCHW documents.
 */
export enum ClauseLinkType {
  VERIFICATION = 'VERIFICATION',
  DOCUMENTATION = 'DOCUMENTATION',
}
